<script>

import { cComponentMixin, coreMixin, dialogsMixin } from 'crud-vue-core'

export default {
  name: 'c-component',
  mixins: [coreMixin, dialogsMixin, cComponentMixin]
}
</script>

<style scoped>

</style>
